module.exports = __webpack_public_path__ + "img/cumin-seeds.c58bbf74.jpg";